<template>
<div>


  
  <b-modal
      id="modal-select-workshop"
      ref="modal-select-workshop"
      title="選擇上課日期"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      size="sm"
      @ok="submit_workshop_datetime()"
      ok-title="Submit"
    >
         <flat-pickr v-model="selected_enrollment.class_date" class="form-control" :config="{ dateFormat: 'Y-m-d', altInput: true,altFormat: 'j F, Y'}" />
                <div class="class-time-panel mt-1">
                    <div class="class-time-label">上課時間</div>
                    <b-row class="align-items-center justify-content-center no-gutters class-time-row">
                    <b-col cols="5">
                        <v-select v-model="selected_enrollment.class_hour" :clearable="false" label="label" :options="hourOptions" :reduce="hour => hour.value" class="class-time-select" />
                    </b-col>
                    <b-col cols="2" class="text-center class-time-separator">
                        :
                    </b-col>
                    <b-col cols="5">
                        <v-select v-model="selected_enrollment.class_minute" :clearable="false" label="label" :options="minuteOptions" :reduce="minute => minute.value" class="class-time-select" />
                    </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      
                      <b-col>
                        <div>上課老師</div>
                        <v-select 
                        v-model="selected_enrollment.user_id"
                        :clearable="false"
                        label="label"
                        :options="staffOptions"
                        :reduce="staff => staff.value"
                        class="class-time-select"
                        />
                      </b-col>
                    </b-row>
                </div>
    </b-modal>


  <b-modal
    id="modal-select-enrollment"
    ref="select-enrollment-modal"
    title="選擇課堂"
    size="sm"
    centered
    hide-footer
  >
    <b-list-group>
      <b-list-group-item
        v-for="enrollment in selectedEnrollments"
        :key="enrollment.id"
        button
        @click="selectEnrollment(enrollment)"
      >
        {{ enrollment.label }}
      </b-list-group-item>
    </b-list-group>
  </b-modal>

  <b-modal
    id="modal-enrollment-actions"
    ref="enrollment-actions-modal"
    title="Enrollment Actions"
    size="sm"
    centered
    hide-footer
    no-close-on-backdrop
    @hidden="resetEnrollmentActions"
  >
    <div v-if="selectedCalendarEnrollment">
      <p class="mb-1">{{ selectedCalendarEnrollment.label }}</p>
      <b-form-group label="順延月份" label-for="t-stop-month">
        <v-select
          id="t-stop-month"
          v-model="selectedTStopMonth"
          :options="tStopMonthOptions"
          :reduce="month => month.value"
          :clearable="false"
          placeholder="選擇順延長度"
        />
      </b-form-group>
      <hr />
      <b-row >
        <b-col cols="7">
          <b-button
            block
            variant="primary"
            :disabled="selectedTStopMonth === null || isSubmittingTStop"
            @click="tstopSelectedEnrollment"
          >
            順延
          </b-button>
        </b-col>
        <b-col cols="5">
          <b-button block variant="danger" @click="deleteSelectedEnrollment">
            刪除此課堂
          </b-button>
        </b-col>
        <b-col cols="7">
            <b-form-input class="mt-1"
              placeholder="輸入日期"
              v-mask="'####-##-## ##:##'"
              v-model="selectedCalendarEnrollment.datetime"
            />

        </b-col>
        <b-col cols="5">
          <b-button class="mt-1" block variant="outline-warning" @click="copySelectedEnrollment" v-if="add_enrollment_permission === true">
            複製此課堂
          </b-button>
        </b-col>
      </b-row>
     
    </div>
  </b-modal>

  <b-modal
      id="workshop_transfer"
      title="工作坊轉移"
       size="sm"
       ref="workshop_transfer"
       centered
      cancel-variant="outline-secondary"
      no-close-on-backdrop
     
    >
      <b-form>
        <b-form-group
          label="學生編號"
          label-for="student_id"
        >
          <b-form-input
            placeholder="學生編號"
            v-model="transfer_student_code"
          />
        </b-form-group>
      
      </b-form>
            <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="transferToStudent()">
        Submit
      </b-button>
    </template>
    </b-modal>


  <b-modal
      id="modal-select2"
      title="新增家長"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      @ok="add_parent()"
      ok-title="Submit"
    >
      <b-form>
        <b-form-group
          label="中文姓名"
          label-for="zh_name"
        >
          <b-form-input
            placeholder="中文姓名"
            v-model="new_parent.zh_name"
          />
        </b-form-group>
        <b-form-group
          label="英文姓名"
          label-for="name"
        >
          <b-form-input
            placeholder="英文姓名"
            v-model="new_parent.en_name"
          />
        </b-form-group>
        <b-form-group
          label="關係"
          label-for="vue-select"
        >
          <v-select
            :options="relationshipOptions"
            :reduce="ans => ans.value"
            v-model="new_parent.relationship"
          />
        </b-form-group>
        <b-form-group
          label="聯絡電話"
          label-for="Mobile"
        >
          <b-form-input
            type="number"
            placeholder="聯絡電話"
            v-model="new_parent.mobile"
          />
        </b-form-group>
      </b-form>
    </b-modal>


  <Snapshot
    :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive"
    :user-data="userData"
    user-type="MEMBER"
    @clicked="one"
  />
    <!-- Header: Personal Info -->
    <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="lg"
      title="Snapshot"
    >
     <embed src="//www.cloudfit.pro/snapshot.php" width="100%" height="600px">
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>


    <b-row>
        <b-col md="5" lg="6">
          <div class="d-flex">
              <feather-icon icon="UserIcon" size="19"/>
              <h4 class="mb-0 ml-50">
                  {{ $t('Personal Information') }}
              </h4>
          </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>

                    <!-- Field: Mobile -->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Student Code')" label-for="member_code">
                            <b-form-input id="code" v-model="userData.code"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Chinese Name" label-for="zh_name">
                            <b-form-input id="zh_name" v-model="userData.zh_name"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="English Name" label-for="en_name">
                            <b-form-input id="en_name" v-model="userData.en_name"/>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" lg="4" v-if="$can('read', 'staff')">
                        <b-form-group label="Date Of Birth" label-for="birth-date">
                            <flat-pickr v-model="userData.birth" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Age" label-for="age">
                            <b-form-input id="age" v-model="userData.age" disabled/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Mobile')" label-for="mobile">
                            <b-form-input id="mobile" v-model="userData.mobile"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group label="Address" label-for="address">
                            <b-form-input id="address" v-model="userData.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group label="E-Mail" label-for="email">
                            <b-form-input id="email" v-model="userData.email"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Gender" label-for="gender">
                            <v-select v-model="userData.gender" :options="genderOptions" :reduce="val=>val.value" :clearable="false" input-id="gender"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Created at')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.created_at" disabled/>
                        </b-form-group>
                    </b-col>

                    <!-- <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('UUID')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.uuid" disabled/>
                        </b-form-group>
                    </b-col> -->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('School Grade')" label-for="status">
                            <v-select v-model="userData.school_grade" :reduce="ans => ans.value" :options="schoolGradeOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="8">
                        <b-form-group :label="$t('Rainbow Grade')" label-for="status">
                            <v-select v-model="userData.grade" :reduce="ans => ans.code" :options="gradeOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('拒收訊息')" label-for="spam">
                            <v-select v-model="userData.spam"  :reduce="spam => spam.value" :options="spamOptions" :clearable="false" input-id="spam"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="8" md="8" lg="8">
                        <b-form-group :label="$t('Group')" label-for="Group">
                          <v-select
                            v-model="userData.groups"
                            multiple
                            label="label"
                            :reduce="group => group.value"
                            :options="groupOption"
                          />
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('負責分校')" label-for="center_id">
                            <v-select v-model="userData.center_id"  :reduce="center => center.value" :options="centerOptions" :clearable="false" input-id="center_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Remarks')" label-for="remarks">
                            <b-form-textarea id="remarks" v-model="userData.remarks"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Timetable Remarks')" label-for="timetable_remarks">
                            <b-form-textarea id="timetable_remarks" v-model="userData.timetable_remarks"/>
                        </b-form-group>
                    </b-col>


                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button
                            variant="primary"
                            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                            @click="save_member"
                            v-if="$can('read', 'staff')">
                            Save Changes
                        </b-button>
                        <b-button variant="outline-secondary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name: 'member-list' }">
                            Cancel
                        </b-button>

                    </b-col>
                    <b-col class="text-right">
                      <b-button
                            variant="danger"
                            @click="delete_member"
                            v-if="$can('read', 'manager')">
                             <span> Delete Student </span>
                        </b-button>
                    </b-col>

                </b-row>
            </b-form>
        </b-col>
        <b-col  md="4" lg="3">
          <v-calendar
            :firstDayOfWeek="0"
            title-position="center"
            :rows="3"
            @dayclick='dayClicked'
            :attributes="attributes" />
         </b-col>
        <b-col  md="4" lg="3">

          <img
            style="width:100%;border-radius:10px;"
            ref="previewEl"
            @error="userData.avatar = ''"
            :src="userData.avatar"
            size="100%"
            class="mb-1"
            rounded
          /><br>

          <b-button
            block
            variant="danger"
            @click="go_to_invoice()"
          >
          <feather-icon icon="ShoppingCartIcon" />
           <span> 付款 </span>
          </b-button>

          <input type="file" ref="fileInput" class="hidden" accept=".jpg, .jpeg" @change="handleClick">
          <b-button
            class="mt-1"
            block
            variant="primary"
            @click="$refs.fileInput.click()"
          >
          <feather-icon icon="CameraIcon" />
           <span> 上載學生相 </span>
          </b-button>
          <b-button
            class="mt-1"
            block
            variant="outline-primary"
            @click="update_card()"
          >
          <feather-icon icon="RssIcon" />
          <span  v-if="userData.card_id"> 更新晶片卡 </span>
          <span  v-if="!userData.card_id"> 登記晶片卡 </span>
          </b-button>

          <b-button
            class="mt-1"
            block
            size="sm"
            variant="warning"
            @click="update_todo()"
          >
          <feather-icon icon="PenToolIcon" />
          <span> 更新作品表 </span>
          </b-button>


          <hr>
        <h4 class="mb-1">  {{ $t('緊急聯絡人') }} <feather-icon icon="PlusCircleIcon" size="19" v-b-modal.modal-select2 /> </h4>
            <b-list-group>
                <b-list-group-item v-for="parent in userData.parents" :key="parent.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{parent.zh_name}}</b><br><span style="font-size:13px;color:#aaa;">{{parent.relationship}} - {{parent.mobile}}</span></span>
                    <b-badge variant="danger" pill class="badge-round" @click="delete_parent(parent.id)">
                        <feather-icon icon="Trash2Icon" size="19"/>
                    </b-badge>
                </b-list-group-item>

            </b-list-group>
            <hr>
        <h4 class="mb-1">  {{ $t('未取物品') }}  </h4>
            <b-list-group>
                <b-list-group-item v-for="item in userData.uncollected" :key="item.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{item.item_name}}</b></span>
                        <feather-icon style="cursor:pointer;" v-if="item.item_type == 'PRODUCT'" icon="CheckSquareIcon" color="green" size="19" @click="collect_item(item.id)" />
                        <feather-icon style="cursor:pointer;" v-if="item.item_type == 'FORM'" icon="BookIcon" color="red" size="19" @click="submit_form(item.form_id,item.id)" />
                </b-list-group-item>
            </b-list-group>
            <hr >
            <h4 class="mb-1">  {{ $t('未選擇工作坊') }}  </h4>

            <b-list-group>
                <b-list-group-item v-for="item in hold_enrollments" :key="item.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{item.id}}{{item.remarks}}</b></span>
                        <feather-icon icon="CalendarIcon" color="blue" size="17" style="cursor:pointer;" @click="workshop_choose_date(item.id)" />
                        <feather-icon icon="RepeatIcon" color="green" size="17" class="ml-50" style="cursor:pointer;" @click="workshop_transfer(item.id)" />
                </b-list-group-item>
            </b-list-group>


        </b-col>
    </b-row>
</div>
</template>



<script>
import {
   BModal, VBModal, BFormTextarea, BCardText, BAlert, BLink, BCard,BMedia, BAvatar, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,BListGroup, BListGroupItem,BBadge
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Snapshot from './SidebarSnapshot.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera'
import moment from 'moment'
import { transformVNodeArgs } from 'vue'

export default {
  components: {
    ToastificationContent,
     BFormTextarea,
     'v-easy-camera': EasyCamera,
     BBadge,
     BCard,
     BModal, VBModal,
     Snapshot,
     BCardText,
    vSelect,
    flatPickr,
    BAvatar,
    BListGroup, BListGroupItem,
    BForm,
    BFormGroup,
    BMedia,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  computed: {
    attributes() {
      return [
        {
          dot: true,
          bar: true,
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'solid',

          },
          //dates: moment('2023-01-10').format()
        },
        ...this.dates.map(date => ({
          highlight: date.color,
          dates: date.class_date,
          popover: {
            label:  date.grade + " " + date.time + " " + date.teacher_name + " (" + date.transaction_code +")",
            enrollment_id : date.id
          },
        })),
      ];
    },
  },
  data() {
    return {
      add_enrollment_permission: false,
      picture: null,
      selected_enrollment: {
        center_id: this.$store.getters['center/currentCenterId'],
        class_date: null,
        class_hour: null,
        class_minute: null,
      },
      hourOptions: [
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
      ],
      minuteOptions: [
        { label: '00', value: '00' },
        { label: '15', value: '15' },
        { label: '30', value: '30' },
        { label: '45', value: '45' },
      ],
      transfer_student_code: null,
      dates:[],
      selectedEnrollments: [],
      selectedCalendarEnrollment: null,
      selectedTStopMonth: null,
      isSubmittingTStop: false,
      tStopMonthOptions: [
        { label: '1個月', value: 1 },
        { label: '2個月', value: 2 },
        { label: '3個月', value: 3 },
       
      ],
      groupOption:[],
      hold_enrollments : [],
      new_parent : {
        zh_name:null,
        en_name:null,
        mobile:null,
        relationship:null,
        student_id:null,
      },
      default_new_parent : {
        zh_name:null,
        en_name:null,
        mobile:null,
        relationship:null,
        student_id:null,
      },
      capturing : false,
      startOnMounted: false,
      centerOptions: [],
      isSnapShotSidebarActive:false,
      staffOptions: [],
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      statusOptions: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Disable', value: 'DISABLED' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      relationshipOptions: [
        { label: '母親', value: '母親' },
        { label: '父親', value: '父親' },
        { label: '外婆', value: '外婆' },
        { label: '外公', value: '外公' },
        { label: '祖母', value: '祖母' },
        { label: '祖父', value: '祖父' },
      ],
      spamOptions: [
        { label: '可接收', value: null },
        { label: '拒收', value: 'Y' },  
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      schoolGradeOptions: [
        { label: 'N', value: 'N' },
        { label: 'K1', value: 'K1' },
        { label: 'K2', value: 'K2' },
        { label: 'K3', value: 'K3' },
        { label: 'P1', value: 'P1' },
        { label: 'P2', value: 'P2' },
        { label: 'P3', value: 'P3' },
        { label: 'P4', value: 'P4' },
        { label: 'P5', value: 'P5' },
        { label: 'P6', value: 'P6' },
        { label: 'S1', value: 'S1' },
        { label: 'S2', value: 'S2' },
        { label: 'S3', value: 'S3' },
        { label: 'S4', value: 'S4' },
        { label: 'S5', value: 'S5' },
        { label: 'S6', value: 'S6' },
        { label: 'ADULT', value: 'ADULT' }
      ],
      gradeOptions: []
    }
  },
  created() {
    console.clear()
    this.get_grade_option()
    this.get_member_data()
    this.get_center_data()
    this.get_staff_list()
    this.get_group_list()
    const storedUserData = JSON.parse(localStorage.getItem('userData') || '{}')
    this.add_enrollment_permission = Array.isArray(storedUserData.allow_to)
      && storedUserData.allow_to.includes('add_enrollment')
  },
  methods: {
    age(dob) {
      var a = moment()
      console.log(a)
      var b = moment(dob, 'YYYY-MM-DD')
      var age = moment.duration(a.diff(b))
      var years = age.years()
      var months = age.months()
      var month_string = ''
      if (months > 0 ) { month_string = months + "個月" }
      return  years + "歲 " + month_string
    },
    submit_workshop_datetime() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/workshop/` + this.selected_enrollment.id + `/change_date/`, this.selected_enrollment)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
             this.selected_enrollment.id = null
             this.$refs['modal-select-workshop'].hide()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
      this.$refs['modal-select-workshop'].hide()
    },
    workshop_choose_date(id) {
      this.selected_enrollment.id = id
      this.$refs['modal-select-workshop'].show()
    },
    workshop_transfer(id) {
      this.selected_enrollment_id = id
      this.$refs['workshop_transfer'].show()
    },
    transferToStudent() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/workshop/` + this.selected_enrollment_id + `/change_student/`, {student_id : this.transfer_student_code})
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
             this.selected_enrollment_id = null
             this.refs['workshop_transfer'].hide()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
       
    },
    copySelectedEnrollment() {
      const enrollmentId = this.selectedCalendarEnrollment.id
      this.isSubmittingTStop = true
      this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/`+ enrollmentId +`/copy/`,{
        month : this.selectedCalendarEnrollment.datetime
      })
        .then(res => {
          if (res.data.result === false) {
            throw new Error(res.data.message || '複製失敗')
          }

          this.$refs['enrollment-actions-modal'].hide()
          this.get_member_data()
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: res.data.message || '複製成功',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message,
            },
          })
        })
        .finally(() => {
         
        })

    },
    submit_form(form_id,item_id) {
      this.$router.push({path : '/form/'+ this.userData.id + "/"+form_id+"/?item_id="+item_id } )
    },
    dayClicked(day) {
      console.clear()
      const enrollments = day.attributes
        .filter(attribute => attribute.popover && attribute.popover.enrollment_id)
        .map(attribute => ({
          id: attribute.popover.enrollment_id,
          label: attribute.popover.label,
        }))
        .filter((enrollment, index, list) => list.findIndex(item => item.id === enrollment.id) === index)

      if (enrollments.length > 1) {
        this.selectedEnrollments = enrollments
        this.$refs['select-enrollment-modal'].show()
      } else if (enrollments.length === 1) {
        this.showEnrollmentActions(enrollments[0])
      }
    },
    selectEnrollment(enrollment) {
      this.$refs['select-enrollment-modal'].hide()
      this.$nextTick(() => this.showEnrollmentActions(enrollment))
    },
    showEnrollmentActions(enrollment) {
      this.selectedCalendarEnrollment = enrollment
      this.selectedTStopMonth = null
      this.$refs['enrollment-actions-modal'].show()
    },
    resetEnrollmentActions() {
      this.selectedCalendarEnrollment = null
      this.selectedTStopMonth = null
      this.isSubmittingTStop = false
    },
    deleteSelectedEnrollment() {
      const enrollmentId = this.selectedCalendarEnrollment.id
      this.$refs['enrollment-actions-modal'].hide()
      this.delete_enrollment(enrollmentId)
    },
    tstopSelectedEnrollment() {
      if (!this.selectedCalendarEnrollment || this.selectedTStopMonth === null || this.isSubmittingTStop) return

      const enrollmentId = this.selectedCalendarEnrollment.id
      this.isSubmittingTStop = true
      this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/`+ enrollmentId +`/tstop/`,{
        month : this.selectedTStopMonth
      })
        .then(res => {
          if (res.data.result === false) {
            throw new Error(res.data.message || '順延失敗')
          }

          this.$refs['enrollment-actions-modal'].hide()
          this.get_member_data()
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: res.data.message || '順延成功',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : error.message,
            },
          })
        })
        .finally(() => {
          this.isSubmittingTStop = false
        })
    },

    signature() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/signature/` + router.currentRoute.params.id + `/send/`)
        .then(res => {

            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Sent!',
              },
            })

        })
    },
    delete_enrollment(enrollment_id) {
      this.$bvModal
        .msgBoxConfirm('確定刪除課堂？', {
          title: '刪除課堂',
          size: 'sm',
          okVariant: 'danger',
          okTitle: '確定刪除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/`+ enrollment_id +`/delete/`,{})
            .then(res => {
              this.get_member_data()
            })
          }
        })
    },
    get_grade_option() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/grades/')
        .then(res => {
          this.gradeOptions = res.data.grades_enable
        })
    },

    go_to_invoice() {
      this.$router.push('/apps/member/'+ router.currentRoute.params.id+'/class/add/')
    },
    test() {
      this.$router.push({ path : '/class-list/' , query : { student_id : "123" }})
    },
    update_todo() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/` + router.currentRoute.params.id + `/update_todo/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          //  this.$router.push('/student-list/')
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/delete/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.$router.push('/student-list/')
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    collect_item(id) {
      this.$http.post(process.env.VUE_APP_API_BASE+`/transaction/item/collect/`, {item_id : id })
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_parent(parent_id) {
      this.$http.post(process.env.VUE_APP_API_BASE+`/parent/delete/`, {student_id : router.currentRoute.params.id , parent_id : parent_id})
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    add_parent() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/parent/`, this.new_parent)
        .then(res => {
          if (res.data.result === true) {
            this.new_parent = this.default_new_parent
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    one() {
      this.isSnapShotSidebarActive = false
      this.get_member_data()
    },
    update_card() {
         localStorage.setItem('reader_action', 'update_member_card')
         localStorage.setItem('student_id', this.userData.id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('member_id')
          }
        })
    },
    go() {
        window.location = 'https://www.cloudfit.pro/snapshot.php?token='+this.userData.token
    },
    snapshot2() {
      this.isSnapShotSidebarActive = true
    },
    start_cam() {
      this.capturing = true
      this.$refs.cam.start()
      this.$refs.cam.start()
    },
    capture() {
      this.$refs.cam.snap()
    },
    old_capture() {
      this.$refs['my-modal'].show()
    },
    void_deposit(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, void deposit!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        this.$http.post(process.env.VUE_APP_API_BASE+`/transaction/`+id+`/delete/`, {})
          .then(res => {
              this.get_member_data()
          })

      })
    },
    get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/')
        .then(res => {
          this.staffOptions = res.data
        })
    },
    get_group_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/groups/')
        .then(res => {
          this.groupOption = res.data
        })
    },
    save_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    snapshot() {
      this.$refs['my-modal'].show()
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
        this.uploadFile(rawFile)
      },
    async uploadFile (file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    },
    readerData (rawFile) {
        this.processing = true
        var file = rawFile
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              console.log( reader.result )
              this.$http.post(process.env.VUE_APP_API_BASE+'/student/'+ router.currentRoute.params.id +'/student_photo/',{ base64 : reader.result })
              .then(res => {
                if (res.data.result === true) {
                  
                  this.get_member_data()
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
            })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
              })
            }
            reader.onerror = function (error) {
                console.log('Error: ', error)
                this.processing = false
            }  
          
      },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_member_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
          this.new_parent.student_id = this.userData.id
          this.userData.age = this.age(res.data.birth)
        })
        this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/enrollments/?perpage=999&page=1&search=null`)
        .then(res => {
          this.userData.enrollments = res.data.enrollments
          this.hold_enrollments = res.data.hold_enrollments
          this.dates = []
          this.userData.enrollments.forEach((enrollment, i) => {
            this.dates.push(enrollment)
            this.dates[i].class_date = moment(enrollment.class_date).format()
          })
          console.log("this.dates", this.dates)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
